/** `inbox` namespace — Swedish (source of truth). */
const inbox = {
  title: 'Inkorg',
  address: {
    label: 'Projektets e-postadress',
    copy: 'Kopiera adressen',
    copied: 'Adressen kopierad',
    hint: 'Mejl som skickas hit hamnar i inkorgen. Regler avgör vad HUB gör med dem.',
    addContact: 'Lägg till som kontakt',
  },
  contact: {
    title: 'Lägg till som kontakt',
    hint: 'Skanna med mobilkameran så sparas projektet som kontakten "{{name}}" i telefonen.',
    download: 'Ladda ner kontaktkort (.vcf)',
    qrAlt: 'QR-kod med projektets kontaktkort',
    loading: 'Skapar QR-kod...',
  },
  folders: {
    inbox: 'Inkorg',
    processed: 'Hanterade',
    archive: 'Arkiv',
  },
  rulesLink: 'Regler',
  searchPlaceholder: 'Sök i inkorgen...',
  empty: {
    inbox: 'Inga mejl i inkorgen',
    processed: 'Inga hanterade mejl ännu',
    archive: 'Arkivet är tomt',
    search: 'Inga mejl matchar sökningen',
  },
  noSubject: '(inget ämne)',
  disabled: {
    title: 'Inkorgen är inte aktiverad',
    description:
      'Projektets inkorg är inte påslagen för din organisation. En administratör kan aktivera den.',
    back: 'Till projektet',
  },
  select: 'Välj ett mejl för att läsa det',
  loading: 'Laddar...',
  status: {
    new: 'Ny',
    no_match: 'Ingen regel',
    matched: 'Regel träffad',
    processing: 'Bearbetas',
    done: 'Klar',
    failed: 'Misslyckades',
  },
  detail: {
    from: 'Från',
    to: 'Till',
    cc: 'Kopia',
    received: 'Mottaget',
    attachments: 'Bilagor',
    download: 'Ladda ner',
    preview: 'Visa {{name}}',
    openPdf: 'Öppna PDF:en',
    closePreview: 'Stäng',
    saveToDocuments: 'Spara i Dokument',
    saved: 'Sparad i Dokument: {{title}}',
    alreadySaved: 'Bilagan finns redan i Dokument: {{title}}',
    openDocument: 'Öppna i Dokument',
    saveFailed: 'Kunde inte spara bilagan',
    copyFrom: 'Kopiera avsändarens adress',
    copiedFrom: 'Adressen kopierad',
    askAboutSelection: 'Fråga HUB',
    emptyBody: '(tomt meddelande)',
    error: 'Fel',
  },
  runs: {
    title: 'Körningar',
    rule: 'Regel: {{name}}',
    manual: 'Manuell fråga',
    openReply: 'Visa HUB:s svar i chatten',
    status: {
      queued: 'Köad',
      running: 'Körs',
      done: 'Klar',
      failed: 'Misslyckades',
    },
  },
  actions: {
    runRule: 'Kör regel',
    runRuleMoves: 'Flyttar mejlet till Hanterade efter körning',
    delete: 'Radera',
    archive: 'Arkivera',
    moveToInbox: 'Flytta till inkorgen',
    markProcessed: 'Markera som hanterad',
    noRules: 'Inga regler ännu',
    manageRules: 'Hantera regler',
  },
  ask: {
    started: 'HUB arbetar med mejlet',
  },
  bubble: {
    title: 'HUB',
    open: 'Öppna HUB',
    collapse: 'Minimera',
    hint: 'Fråga HUB om mejlet – svara, spara bilagor, skapa uppgifter…',
    placeholder: 'Fråga HUB om mejlet eller be om en åtgärd…',
  },
  delete: {
    title: 'Radera mejlet?',
    description:
      'Mejlet, dess bilagor och HUB:s chatt om det tas bort permanent. Dokument som sparats från bilagorna finns kvar.',
    cancel: 'Avbryt',
    confirm: 'Radera',
    done: 'Mejlet har raderats',
    failed: 'Kunde inte radera mejlet',
    processing: 'HUB arbetar fortfarande med mejlet – vänta tills körningen är klar.',
  },
  credits: {
    exhausted: 'Krediterna är slut – körningen kunde inte startas.',
  },
  rules: {
    title: 'Inkorgsregler',
    description:
      'Regler prövas uppifrån och ner när ett mejl kommer in. Den första regeln som matchar startar HUB med sin instruktion.',
    back: 'Tillbaka till inkorgen',
    create: 'Ny regel',
    empty: 'Inga regler ännu. Skapa en regel för att låta HUB hantera inkommande mejl automatiskt.',
    enabled: 'Aktiv',
    disabled: 'Inaktiv',
    moveUp: 'Flytta upp',
    moveDown: 'Flytta ner',
    edit: 'Redigera',
    delete: 'Ta bort',
    deleteTitle: 'Ta bort regeln?',
    deleteDescription: '"{{name}}" tas bort. Redan startade körningar påverkas inte.',
    conditionsSummary_one: '{{count}} villkor',
    conditionsSummary_other: '{{count}} villkor',
    matchAll: 'alla måste stämma',
    matchAny: 'något måste stämma',
    autoArchiveOn: 'Flyttas till Hanterade efter körning',
    editor: {
      createTitle: 'Ny regel',
      editTitle: 'Redigera regel',
      name: 'Namn',
      namePlaceholder: 'T.ex. Fakturor från leverantörer',
      enabled: 'Regeln är aktiv',
      conditions: 'Villkor',
      matchMode: 'Kör när',
      matchAll: 'alla villkor stämmer',
      matchAny: 'något villkor stämmer',
      addCondition: 'Lägg till villkor',
      removeCondition: 'Ta bort villkor',
      valuePlaceholder: 'Värde',
      prompt: 'Instruktion till HUB',
      promptPlaceholder:
        'T.ex. Spara bilagan i Dokument, sammanfatta fakturan och skapa en uppgift för attest.',
      promptHint:
        'HUB får mejlet som underlag och kan läsa bilagor, spara dem i Dokument, skapa uppgifter och svara på mejlet.',
      autoArchive: 'Flytta mejlet till Hanterade när körningen är klar',
      test: 'Testa mot senaste mejlen',
      testResult_one: 'Matchar {{count}} av de senaste {{total}} mejlen',
      testResult_other: 'Matchar {{count}} av de senaste {{total}} mejlen',
      testEmpty: 'Inget av de senaste mejlen matchar',
      save: 'Spara',
      cancel: 'Avbryt',
      saved: 'Regeln sparad',
      validation: 'Fyll i namn, minst ett villkor med värde och en instruktion.',
    },
    fields: {
      from: 'Avsändare',
      subject: 'Ämne',
      body: 'Meddelande',
      to: 'Mottagare',
      has_attachment: 'Har bilaga',
      attachment_name: 'Bilagans namn',
    },
    ops: {
      contains: 'innehåller',
      equals: 'är exakt',
      starts_with: 'börjar med',
      ends_with: 'slutar med',
      is: 'är',
    },
    bool: {
      true: 'Ja',
      false: 'Nej',
    },
  },
}

export default inbox
